import { call } from 'redux-saga/effects';
import { omitBy, isNil } from 'lodash/fp';
import * as Api from '../../../services/fbm-api';
import * as routines from './routines';
import { sagaRoutineRequest } from '../../../helpers/saga';

export const fetchClients = ({ payload: query }) => {
  const qs = omitBy(each => !each && isNil(each), query);
  return sagaRoutineRequest(routines.fetchClients, {
    request: () => call(Api.fetchClients, { qs })
  });
};

export const fetchClient = ({ payload: id }) =>
  sagaRoutineRequest(routines.fetchClient, {
    request: () => call(Api.fetchClient, id)
  });

export const fetchClientColumns = () =>
  sagaRoutineRequest(routines.fetchClientColumns, {
    request: () => call(Api.fetchClientColumns)
  });

export const fetchClientByBarcode = ({ payload: barcode }) =>
  sagaRoutineRequest(routines.fetchClientByBarcode, {
    request: () => call(Api.fetchClientByBarcode, barcode)
  });
